import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
/* import Route from '../src/Route'; */
import reportWebVitals from './reportWebVitals';
import App from './components/App';
import Authorization from "./auth/Authorization"
ReactDOM.render(
  <React.StrictMode>
<Authorization>
    <App/>
    </Authorization>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
